import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import { searchUserApis } from "../../services/userHeadquarter/UserSearchingServices";

export default function UsersSearchingPage() {

    const [users, setUsers] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState({});

    const createOptions = (list) => {

        const unique = [...new Set(list)];

        return unique.map(user => ({
            label: user,
            value: user
        }));

    };

    const parseUsers = (text) => {

        if (!text) return [];

        text = text.trim();

        let values = [];

        try {

            const arr = JSON.parse(text);

            if (Array.isArray(arr)) {
                values = arr;
            }

        } catch {

            values = text
                .replace(/[\[\]"']/g, "")
                .split(/[\n,;\t ]+/)
                .map(x => x.trim())
                .filter(Boolean);

        }

        return values;

    };

    const handleInputChange = (value, actionMeta) => {

        if (actionMeta.action !== "input-change") {
            return value;
        }

        // Detect paste or multiple values
        if (
            value.includes(",") ||
            value.includes("\n") ||
            value.includes("[") ||
            value.includes('"')
        ) {

            const parsed = parseUsers(value);

            if (parsed.length) {

                setUsers(prev => {

                    const all = [
                        ...prev.map(x => x.value),
                        ...parsed
                    ];

                    return createOptions(all);

                });

                return "";
            }
        }

        setInputValue(value);

        return value;
    };

    const handleKeyDown = (e) => {

        if (!inputValue) return;

        if (e.key === "Enter" || e.key === "Tab" || e.key === ",") {

            e.preventDefault();

            const parsed = parseUsers(inputValue);

            setUsers(prev => {

                const all = [
                    ...prev.map(x => x.value),
                    ...parsed
                ];

                return createOptions(all);

            });

            setInputValue("");

        }

    };

    const searchUsers = async () => {

        if (!users.length) {
            alert("Please enter users");
            return;
        }

        try {

            setLoading(true);

            const payload = users.map(x => x.value);

            const res = await searchUserApis({
                users: payload
            });

            setResult(res.data || {});

        }
        catch (e) {
            console.log(e);
        }
        finally {
            setLoading(false);
        }

    };

    return (

        <div className="container mt-4">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h4 className="mb-0">
                        Users Searching
                    </h4>

                </div>

                <div className="card-body">

                    <CreatableSelect

                        isMulti

                        value={users}

                        inputValue={inputValue}

                        onInputChange={handleInputChange}

                        onKeyDown={handleKeyDown}

                        onChange={setUsers}

                        placeholder="Paste JSON Array / comma / newline separated users"

                    />

                    <button
                        className="btn btn-primary mt-3"
                        onClick={searchUsers}
                        disabled={loading}
                    >
                        {loading ? "Searching..." : "Search"}
                    </button>

                </div>

            </div>

            {

                Object.entries(result).map(([tableName, rows]) => (

                    <div className="card mt-4" key={tableName}>

                        <div className="card-header bg-success text-white">

                            {tableName}

                            <span className="badge bg-light text-dark ms-2">

                                {rows.length}

                            </span>

                        </div>

                        <div className="card-body">

                            {

                                rows.length === 0 ?

                                    <div className="alert alert-warning">

                                        No Records Found

                                    </div>

                                    :

                                    <div className="table-responsive">

                                        <table className="table table-bordered table-striped">

                                            <thead>

                                                <tr>

                                                    {

                                                        Object.keys(rows[0]).map(col => (

                                                            <th key={col}>{col}</th>

                                                        ))

                                                    }

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {

                                                    rows.map((row, i) => (

                                                        <tr key={i}>

                                                            {

                                                                Object.keys(row).map(key => (

                                                                    <td key={key}>

                                                                        {String(row[key] ?? "-")}

                                                                    </td>

                                                                ))

                                                            }

                                                        </tr>

                                                    ))

                                                }

                                            </tbody>

                                        </table>

                                    </div>

                            }

                        </div>

                    </div>

                ))

            }

        </div>

    );

}